export const gitStreamCheckboxTooltips = {
  ALL_REPOS_CHECKED:
    'All repos are currently connected to gitStream. Click to disconnect all repos.',
  ALL_REPOS_EMPTY:
    'All repos are currently disconnected from gitStream. Click to connect all repos.',
  ALL_REPOS_DASH: 'Some repos are connected to gitStream, click to connect all',
  SINGLE_REPO_CHECKED: 'Repo is connected to gitStream, click to disconnect',
  SINGLE_REPO_EMPTY: 'Repo is disconnected from gitStream, click to connect',
  CM_REPO_CHECKED: 'Disable gitStream by toggling this repo',
  CM_REPO_EMPTY: 'Enable gitStream by selecting this repo'
};
